import HeroAnchor from '../HeroAnchor';

import ErrorMessageConstants from '../../constants/ErrorMessageConstants';
// import appLogger from '../loggers/appLogger';

export type LocationRestrictionProps = {
  duplicateExists: boolean;
  duplicateSyndicatedUrl: string | null;
  forSaleExists: boolean;
  forSaleUrlOnZillow: string | null;
  isTopListingOwner: boolean;
  paidListingExists: boolean;
  paidMultifamilyLocation: boolean;
  restrictedFromNyc: boolean;
  duplicateAccountListingId: string;
};

const LocationRestrictionErrorMessage = (
  {
    duplicateExists,
    duplicateSyndicatedUrl,
    forSaleExists,
    forSaleUrlOnZillow,
    isTopListingOwner,
    paidListingExists,
    paidMultifamilyLocation,
    restrictedFromNyc,
  }: LocationRestrictionProps,
  isMultifamily = false,
  isMultifamilyCustomer = false,
  hasActiveMultifamilyContract = false,
  isSingleFamilyEnterpriseCustomer = false,
  isPostingPathAdmin = false,
  isHousingConnector = false,
): string | Array<string | JSX.Element> | null => {
  const learnMoreElement = (
    <HeroAnchor
      href="https://www.zillow.help/article/why-didnt-my-listing-go-live-zd30234367973523"
      target="_blank"
      rel="noopener noreferrer"
    >
      Learn more
    </HeroAnchor>
  );
  const propertyAlreadyPostedElements = (href: string) => [
    'This property is ',
    <HeroAnchor key="propertyAlreadyPostedElements" href={href} target="_blank" rel="noopener noreferrer">
      already posted
    </HeroAnchor>,
  ];
  const logErrorAndReturn = (message: Array<string | JSX.Element> | string) => {
    // appLogger.logError({
    //   message: typeof message === 'string' ? message : '',
    //   context: 'handleLocationRestrictionResponse',
    // }); // // logger is not supported on ZMC yet
    // eslint-disable-next-line
    console.error(`ERROR: ${typeof message === 'string' ? message : ''} :: Context: handleLocationRestrictionResponse`);
    return message;
  };

  if (restrictedFromNyc) {
    const message = ErrorMessageConstants.LOCATION_RESTRICTION.NYC;
    return logErrorAndReturn(message);
  }

  if (!isPostingPathAdmin && !isHousingConnector && paidMultifamilyLocation && !hasActiveMultifamilyContract) {
    const message = ErrorMessageConstants.LOCATION_RESTRICTION.MF_REQUIRED;
    return logErrorAndReturn(message);
  }

  if (forSaleExists && !isMultifamily) {
    if (forSaleUrlOnZillow) {
      const message = [
        ...propertyAlreadyPostedElements(forSaleUrlOnZillow),
        ' for sale. Listings cannot be listed for rent and for sale at the same time. ',
        learnMoreElement,
      ];
      return logErrorAndReturn(message);
    }

    const message = [
      'This property was already posted for sale elsewhere. Listings cannot be listed for rent and for sale at the same time. ',
      learnMoreElement,
    ];
    return logErrorAndReturn(message);
  }

  if (paidListingExists && !isTopListingOwner) {
    return logErrorAndReturn(
      ErrorMessageConstants.PAID_LISTING_DUPE_ERROR(
        isMultifamily && isMultifamilyCustomer,
        isSingleFamilyEnterpriseCustomer,
      ),
    );
  }

  if (duplicateExists) {
    if (duplicateSyndicatedUrl) {
      const message = [
        ...propertyAlreadyPostedElements(duplicateSyndicatedUrl),
        ' from another source. ',
        learnMoreElement,
      ];
      return logErrorAndReturn(message);
    }
    const message = ErrorMessageConstants.LOCATION_RESTRICTION.DUPLICATE.MESSAGE;
    return logErrorAndReturn(message);
  }

  return null;
};

export default LocationRestrictionErrorMessage;
